import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';

// Rxjs
import { Observable } from 'rxjs/Observable';

// Reducers & Actions
import * as Account from '../../../my-account/actions/account.actions';
import * as fromCore from '../../../core/reducers';
import * as fromAuth from '../../../auth/reducers';

// Services
import { TranslationService } from '../../../translation/services/translation.service';

@Component({
  selector: 'privacy-modal',
  templateUrl: './privacy-modal.component.html',
  styleUrls: ['./privacy-modal.component.scss']
})
export class PrivacyModalComponent implements OnInit {

  // Should show
  @Input() show: boolean = false;

  // Public variables
  public langPickerOpened: boolean = false;
  public currentPrivacyLang;

  // Observables
  public privacy$: Observable<string> = this.coreStore.select(state => state.core.account.privacy);

  // Construcotr
  constructor(
    private router: Router,
    private coreStore: Store<fromCore.State>,
    private translationService: TranslationService
  ) { }

  // On component init
  ngOnInit() {
    // Getting license language by default (English)
    this.currentPrivacyLang = this.translationService.langsAvailable[0];
  }

  // Get languages availables
  public get languagesAvailable(): Array<any> {
    return this.translationService.langsAvailable;
  }

  // Toggle license agreement modal
  public togglePrivacyModal(): void {
    this.coreStore.dispatch(new Account.TogglePrivacyModal());
  }

  // Toggle lang picker dropdown
  public toggleLangPicker(): void {
    this.langPickerOpened = !this.langPickerOpened;
  }

  // Change license language
  public changePrivacyLang(lang): void {
    // Toggle lang picker
    this.toggleLangPicker();
    // Save new lang
    this.currentPrivacyLang = lang;
    // Get the new license
    this.coreStore.dispatch(new Account.GetPrivacy(this.currentPrivacyLang.code));
  }
  public scroll(el: HTMLElement) {
    el.scrollIntoView();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/privacy-modal/privacy-modal.component.ts